import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

import Pictures from "./Pictures";

const PicturesPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const clickBackButton = React.useCallback(
    (e: Event) => {
      e.preventDefault();
      navigate(-1);
    },
    [navigate]
  );

  useEffect(() => {
    document.addEventListener("back", clickBackButton);

    return () => {
      document.removeEventListener("back", clickBackButton);
    };
  }, [clickBackButton]);

  const params = new URLSearchParams(location.search);
  const startDate = params.get("startDate") || "";
  const endDate = params.get("endDate") || "";
  const classId = params.get("classId");

  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <div className="flex-1">
        <Pictures
          startDate={startDate}
          endDate={endDate}
          classId={classId ? Number(classId) : undefined}
        />
      </div>
    </section>
  );
};

export default PicturesPage;
